import { render } from "./GlobalHeader.vue?vue&type=template&id=0834067d&scoped=true"
import script from "./GlobalHeader.vue?vue&type=script&lang=js"
export * from "./GlobalHeader.vue?vue&type=script&lang=js"

import "./GlobalHeader.vue?vue&type=style&index=0&id=0834067d&lang=less&scoped=true"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0834067d"]])

export default __exports__